import { TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useField } from "formik";
import { FC } from "react";
import { Link } from "react-router-dom";
import { isExists } from "../../utils";

const CssTextField = styled(TextField)(({ theme }) => ({
  "& label.Mui-focused": {
    color: "#0063cc",
  },
  "& label.Mui-disabled": {
    color:
      localStorage.getItem("dark") === "true"
        ? "rgba(255, 255, 255, 0.38) !important"
        : "rgba(0, 0, 0, 0.38)",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#0063cc",
  },
  ".MuiOutlinedInput-input.Mui-disabled": {
    textFillColor:
      localStorage.getItem("dark") === "true"
        ? "rgba(255, 255, 255, 0.38) !important"
        : "rgba(0, 0, 0, 0.38)",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor:
        theme.palette.mode === "dark" ? "rgb(204 204 204 / 45%)" : "#e5e5e5",
    },
    "&.Mui-disabled": {
      color:
        localStorage.getItem("dark") === "true"
          ? "rgba(255, 255, 255, 0.38)"
          : "rgba(0, 0, 0, 0.38)",
      fieldset: {
        borderColor:
          localStorage.getItem("dark") === "true"
            ? "rgba(255, 255, 255, 0.38)"
            : "rgba(0, 0, 0, 0.38)",
      },
    },

    "&:hover fieldset": {
      borderColor: "#0063cc",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#0063cc",
    },
    "& input": {
      cursor: "pointer",
    },
  },
}));

interface ITextInput {
  name: string;
  label?: string;
  onKeyPressCapture?: any;
  type?: string;
  rows?: number;
  multiline?: boolean;
  readonly?: boolean;
  disabled?: boolean;
  placeholder?: string;
  style?: any;
  autoComplete?: string;
  inputProps?: any;
  redirect: string;
}

const TextInput: FC<ITextInput> = ({
  name,
  style,
  redirect,
  ...otherProps
}) => {
  const [field, meta] = useField(name);

  const configTextfield = {
    ...field,
    ...otherProps,
    fullWidth: true,
    value: isExists(field.value) ? field.value : "",
  };

  return (
    <Link to={redirect}>
      <CssTextField
        error={Boolean(meta.error)}
        helperText={meta.touched && meta.error}
        style={style}
        {...configTextfield}
      />
    </Link>
  );
};

export default TextInput;
